import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  document = inject(DOCUMENT);

  setFavicon(iconUrl: string): void {
    // Find the link element with rel="icon" or "shortcut icon"
    const head = this.document.getElementsByTagName('head')[0];
    let element: HTMLLinkElement | null = this.document.querySelector(`link[rel*='icon']`);

    // If it doesn't exist, create it
    if (!element) {
      element = this.document.createElement('link');
      element.rel = 'icon';
      if (head) {
        head.appendChild(element);
      }
    }

    // Keep `type` in sync with the actual icon data — a stale/mismatched type
    // (e.g. leftover "image/x-icon" on an SVG data URI) can make some browsers
    // silently reject the icon and fall back to the static /favicon.ico instead.
    const dataUriMatch = /^data:(image\/[a-z0-9+.-]+)[;,]/i.exec(iconUrl);
    element.type = dataUriMatch?.[1] ?? '';
    element.href = iconUrl;
  }
}
